import React, { useEffect, Fragment } from "react";
import {
    createMarkup,
    loadImage,
    moment_datetime,
} from "../../../helpers/functions";
import ShowFileDowload from "./ShowFileDowload";
import { Helmet } from "react-helmet";
import InterestedContent from "../../components/Utils/InterestedContent";
function ShowPhoto({ data }) {
    // useEffect(() => {
    //     // $(".popup").magnificPopup({
    //     //     type: "image",
    //     //     gallery: {
    //     //         enabled: true
    //     //     }
    //     // });
    // }, [data]);

    return (
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <Helmet>
                <link
                    rel="stylesheet"
                    type="text/css"
                    href="/info/assets/css/plugins.min.css"
                />

                <link
                    rel="stylesheet"
                    type="text/css"
                    href="/info/argon-design-system/vendor/nucleo/css/nucleo.css"
                />
            </Helmet>
            <div className="grid grid-cols-12 gap-2">
                <div className="bg-white  p-2 col-span-12 lg:col-span-12 md:col-span-10 border-none lg:border-r-2 md:border-r-2 border-gray-200">
                    {data.show && data.show.nphoto && data.show.nphoto ? (
                        <div className="w-full mt-2 mb-2">
                            <img
                                className="rounded shadow justify-center m-auto"
                                src={`${loadImage(
                                    data.show && data.show.nphoto,
                                    data.show.Category
                                )}`}
                            />
                        </div>
                    ) : (
                        <div className="mt-2 mb-2"></div>
                    )}
                    <h1 className="text-sm md:text-base lg:text-lg  text-gray-800 py-1 md:py-2">
                        {data.show && data.show.Question}
                    </h1>
                    <div className="mb-2 border-b-4 border-[#00B4D8] p-2 shadow-b">
                        {" "}
                    </div>
                    <div className="text-content-xs">
                        <i className="fa fa-clock-o" />
                        &nbsp;{data.show && moment_datetime(data.show.Date)}
                        &nbsp;&nbsp;
                        <i className="fa fa-eye" />
                        &nbsp;{data.show && data.show.pageview}
                    </div>

                    <div
                        className="album-header-detail"
                        dangerouslySetInnerHTML={createMarkup(
                            data.show && data.show.Note
                        )}
                    ></div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="album-picture-item">
                                {data.pic_activity &&
                                    data.pic_activity.map((val, i) => (
                                        <div className="item" key={i}>
                                            <div style={{ padding: 10 }}>
                                                <a
                                                    data-fancybox="gallery"
                                                    href={`mediafiles/pic_activity/${val.path_img}`}
                                                    itemProp="url"
                                                >
                                                    <img
                                                        src={`mediafiles/pic_activity/${val.path_img}`}
                                                        alt={val.path_img}
                                                        itemProp="image"
                                                    />
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                                <div style={{ clear: "both" }} />
                            </div>
                        </div>
                    </div>
                    <div className="news-footer">
                        <div className="row">
                            <div className="col-md-12">
                                {data.show && data.show.ndata && (
                                    <ShowFileDowload
                                        data={data.show}
                                        nlink={data.show.nlink}
                                    />
                                )}

                                <div className="news-picture-item">
                                    <div style={{ clear: "both" }} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 text-left"></div>
                        </div>
                    </div>
                </div>
                <div className="col-span-12 lg:col-span-2 md:col-span-2">
                    {/* <div
                        className={`text-base lg:text-lg mt-1 lg:mt-5 md:mt-4 md:text-lg text-center font-bold  border-b-4
                         border-gray-400 border-solid rounded-full bg-[#FFDA3C] pl-2 pr-2 mb-2
                         hover:bg-[#FF0] hover:text-black
                    `}
                    >
                        {` "เนื้อหาน่าสนใจ" `}
                    </div> */}
                    {/* <InterestedContent /> */}
                </div>
            </div>
        </div>
    );
}

export default ShowPhoto;
